export default __webpack_public_path__ + "media/images/collect-core-shape-6-e210f86a.svg";